// CSV 셀 포맷·인코딩 공용 유틸 — 의존성을 두지 않는다. `src/conf.js` 는 window 에 의존해 node 환경 jest 에서
// 깨진다(frontend/docs/wiki/domain/rules/testing.md).
export const CSV_BOM = '\uFEFF'
export const CSV_LINE_BREAK = '\r\n'

// 모든 셀을 따옴표로 감싼다(spec D11) — 값에 쉼표·줄바꿈·앞뒤 공백이 있어도 같은 규칙으로 쓴다
export const formatCsvCell = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`
export const formatCsvRow = (cells) => cells.map(formatCsvCell).join(',')

const tryDecode = (buffer, label) => {
  try {
    return new TextDecoder(label, { fatal: true }).decode(buffer)
  } catch {
    // 해석 불가·미지원 레이블 모두 null — 호출측이 차단한다(spec D12)
    return null
  }
}

// 해석 불가를 비엄격 디코드(U+FFFD 치환)로 넘기지 않는다 — 깨진 글자가 조용히 저장된다(spec D12)
export const decodeCsvBytes = (buffer, fallbackEncoding) => {
  const utf8 = tryDecode(buffer, 'utf-8')
  if (utf8 != null) return { text: utf8, encoding: 'utf-8' }
  const fallback = fallbackEncoding ? tryDecode(buffer, fallbackEncoding) : null
  return fallback != null
    ? { text: fallback, encoding: fallbackEncoding }
    : { text: null, encoding: null }
}

// 단위 테스트하지 않는다 — jsdom 에 Blob.arrayBuffer 가 없어 파일을 읽는 이 얇은 래퍼는 브라우저 QC 로 본다
export const readCsvText = async (file, fallbackEncoding) =>
  decodeCsvBytes(await file.arrayBuffer(), fallbackEncoding)
